export default "__VITE_ASSET__BF4A$yLR__"